<template>
  <div class="CSChatThai" >
    <Navbar/>
    <div class="CSChatThai hidden-sm-and-down"  style="width: 100%; height: 100vh; align-content: center; background-color: white;">
      <v-card flat tile class="lighten-1 white--text text-xs-center" id="contact" >
        <v-layout  justify-center  align-center>
          <v-flex xs12 sm4 offset-sm1  class="CSChatThai" style="margin-top: 10vh;">
            <v-layout align-center column justify-center style="height: 100%;">
            <v-card class="elevation-0 transparent" style="width: 100%" >
              <v-card-title primary-title class="layout justify-center" style="text-align: left;">
                <div class="headline CSChatThai">ส่งข้อความถึงเรา</div>
              </v-card-title>
                <v-text-field
                  label="ชื่อ"
                  v-model="name"
                  single-line
                  solo
                  required
                  class="InputEdit"
                  ></v-text-field>
                  <!-- <br/> -->
                <!-- <br/><br/> -->
                <!-- <input type="text" placeholder="ที่อยู่อีเมล" class="InputEdit" v-model="email">
                <br/><br/>
                <input type="text" placeholder="เบอร์โทรศัพท์" class="InputEdit" v-model="phone">
                <br/><br/> -->
                <v-text-field
                  label="อีเมล"
                  v-model="email"
                  :rules="emailRules"
                  single-line
                  solo
                  required
                  class="InputEdit"
                  ></v-text-field>
                  <!-- <br/> -->
                <v-text-field
                  label="หมายเลขโทรศัพท์"
                  v-model="phone"
                  mask="###-###-####"
                  :rules="phoneRules"
                  required
                  single-line
                  solo
                  class="InputEdit"
                ></v-text-field>
<!-- <br/> -->
                <div  style="width: 100%;">
                <v-menu bottom offset-y style="width: 100%;height: 45px;" class="InputEdit">
                  <v-btn  flat slot="activator" row wrap style="width: 100%;padding: 0;margin: 0; font-size: 14px;">
                    <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: #757575;" v-if="!title.category_TH">หัวข้อ</p>
                    <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: black;" else>{{title.category_TH}}</p>
                    <v-spacer></v-spacer>
                    <v-icon style="font-size: 25px !important; color: #929292;">expand_more</v-icon>
                  </v-btn>
                  <div style="background: white;height: 300px;">
                  <b style="padding: 5px !important;font-size: 15px;color: white;background: #2562af;" class="CSChatThai" >รายงานปัญหา ::</b>
                  <v-list>
                    <v-list-tile v-for="(item, index) in items.list_report"  @click="title = item;" style="background: white;">
                      <v-list-tile-title class="CSChatThai" style="font-size: 14px;">{{ item.category_TH }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>

                  <div style="background: white;">
                 <!--  <b style="padding: 5px !important;font-size: 15px;color: #2662af;" class="CSChatThai" >ข้อเสนอแนะ</b> -->
                  <b style="padding: 5px !important;font-size: 15px;color: white;background: #2562af;" class="CSChatThai" >ข้อเสนอแนะ ::</b>
                  <v-list >
                    <v-list-tile v-for="(item, index) in items.list_feedback"  @click="title = item;" style="background: white;">
                      <v-list-tile-title class="CSChatThai" style="font-size: 14px;">{{ item.category_TH }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </div>
                </div>
                </v-menu>
              </div>
                <!-- <br/> -->
                <!-- <input type="text" placeholder="รายละเอียด" class="InputEdit" v-model="detail" rows="8"> -->
               <!--  <v-textarea
                  v-model="detail"
                  placeholder="รายละเอียด"
                  counter
                  maxlength="255"
                  full-width
                  single-line
                  solo
                  height="60"
                ></v-textarea> -->

                <v-textarea
          v-model="detail"
          placeholder="รายละเอียด"
          counter
          maxlength="255"
          full-width
          class="InputEdit"
          style="height: 120px;resize: none; margin-bottom: 15px;"
        ></v-textarea>
        <form ref="fileform">
        <v-flex xs12 sm12 md12 xl12  style="" class="containers hidden-sm-and-down listfile">
          <!-- <form ref="fileform"> -->
                <div class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-left: 10px;" v-if="key < 5">
                  <a class="close-classic" @click="removeFile( key )"></a>
                  <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;padding-top: 15px;">
                    <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 30px !important; width:30px !important;display: flex;justify-content: center;    margin-left: 20px;" />
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                  <div v-else style="text-align: center; display: grid; justify-content: center;" >
                    <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                </div>


                 <!-- <form ref="fileform"> -->
                <div  :style="borderinputfile" @click="uppic()" v-if="files.length < 5">

            <v-icon style="color: #757575;">mdi-plus-circle</v-icon>
                  <p style="color: #757575;">
                    อัปโหลดรูปภาพ
                  </p>
            <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp"/>

                </div>

              </v-flex>
            </form>
              <!-- <br/> -->
         <!--      <form ref="fileform" style="float: left;">
                <label>
                  <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">เลือกรูปภาพ</b>
                  <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp"/>
                </label>
              </form> -->


              <v-layout row wrap align-center justify-center>
                <v-btn dark  color="blue"  @click="sendfeedback()" v-if="name !== '' && email !== '' && title.category_TH && detail !== ''">
                  <span >ส่งถึงเรา</span>
                </v-btn>
                <v-btn disabled v-else>
                  <span >ส่งถึงเรา</span>
                </v-btn>
                <v-btn dark style="color: white !important; background: #2662af;"  @click="clear()">
                  <span >ยกเลิก</span>
                </v-btn>
              </v-layout>
            </v-card>
          </v-layout>
          </v-flex>
          <v-flex xs12 sm4 offset-sm1 class="CSChatThai">
            <v-card class="elevation-0 transparent" style="margin-top:7vh;">
              <v-card-title primary-title class="layout justify-center" style="text-align: left;">
                <div class="headline CSChatThai">บริษัท วัน เซ็นทริค จำกัด</div>
              </v-card-title>
              <v-card-media height="20vw" src="/static/img/onechat/map.png" >
            </v-card-media>
              <v-layout>
                <v-icon class="blue--text text--lighten-2">place</v-icon>
                <v-card-text class="CSChatThai" style="text-align: left;">
                  บริษัท วัน เซ็นทริค จำกัด <br>1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16
                  ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ
                  เขตห้วยขวาง กรุงเทพมหานคร 10310
                </v-card-text>
              </v-layout>
              <v-layout >
                <v-icon class="blue--text text--lighten-2">email</v-icon>
                <v-card-text class="CSChatThai maildata" style="text-align: left;">
                  <a href="mailto:onechat@one.th" class="">onechat@one.th</a>
                </v-card-text>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
      <!-- footer web -->
      <div class="footer hidden-sm-and-down">
        <v-layout align-center row justify-center>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toNewTab()">API</a></b></p>
          <p style="padding-left: 20px; padding-right: 20px; color: black;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a></b> |</p>
          <p class="CSChatThai" style="padding-left: 5px;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
        </v-layout>
      </div>
    </div>
    <!-- mobile -->
    <div class="CSChatThai hidden-md-and-up" id="contactmo">
      <v-layout row wrap justify-center background-color: white >
        <v-flex xs12 sm4>
          <v-layout align-center column justify-center style="height: 100%;">
            <v-card class="elevation-0 transparent" style="width: 100%; margin-top: 10vh; padding-left: 10px;" >
              <v-card-title primary-title class="layout justify-center" style="text-align: left;">
                <div class="headline CSChatThai">ส่งข้อความถึงเรา</div>
              </v-card-title>
               <!--  <input type="text" placeholder="ชื่อ" class="InputEdit" v-model="name">
                <br/><br/> -->
                <v-text-field
                  label="ชื่อ"
                  v-model="name"
                  single-line
                  solo
                  required
                    class="InputEdit"

                  ></v-text-field>
                <!-- <input type="text" placeholder="ที่อยู่อีเมล" class="InputEdit" v-model="email">
                <br/><br/>
                <input type="text" placeholder="เบอร์โทรศัพท์" class="InputEdit" v-model="phone">
                <br/><br/> -->
                <v-text-field
                  label="อีเมล"
                  v-model="email"
                  :rules="emailRules"
                  single-line
                  solo
                  required
                  class="InputEdit"

                  ></v-text-field>
                <v-text-field
                  label="หมายเลขโทรศัพท์"
                  v-model="phone"
                  mask="###-###-####"
                  :rules="phoneRules"
                  required
                  single-line
                  solo
                  class="InputEdit"
                ></v-text-field>

           <div class="InputEdit" style="width: 100%;">
                <v-menu bottom offset-y style="width: 100%; height: 20px; margin-bottom: 7px;">
                  <v-btn  flat slot="activator" row wrap style="width: 100%;padding: 0;margin: 0;">
                    <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: #757575;" v-if="!title.category_TH">หัวข้อ</p>
                    <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: black;" else>{{title.category_TH}}</p>
                    <v-spacer></v-spacer>
                    <v-icon style="font-size: 25px !important; color: #929292;">expand_more</v-icon>
                  </v-btn>
                  <div style="background: white;height: 300px;">
                    <div style="background-color: #2562af; color: white; font-size: 16px; font-weight: 800;">
                      <span style="padding: 5px !important;" class="CSChatThai" >รายงานปัญหา</span>
                    </div>
                    <v-list>
                    <v-list-tile v-for="(item, index) in items.list_report"  @click="title = item;" style="background: white;">
                      <v-list-tile-title class="CSChatThai" >{{ item.category_TH }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>

                  <div style="background: white;">
                    <div style="background-color: #2562af; color: white; font-size: 16px; font-weight: 800;">
                      <span style="padding: 5px !important;" class="CSChatThai" >ข้อเสนอแนะ</span>
                    </div>
                  <v-list >
                    <v-list-tile v-for="(item, index) in items.list_feedback"  @click="title = item;" style="background: white;">
                      <v-list-tile-title class="CSChatThai" >{{ item.category_TH }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </div>
                </div>
                </v-menu>
              </div>
                <br/>
                <v-textarea
                  v-model="detail"
                  placeholder="รายละเอียด"
                  counter
                  maxlength="255"
                  full-width
                  single-line
                  solo
                  height="85"
                  style="border-style: solid; border-width: thin; border-color: #e5e9eb; border-radius: 4px; height: 90px !important;"
                ></v-textarea>
              <br/>
              <form ref="fileformmo" style="float: left; display: none;">
                <label>
                  <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">เลือกรูปภาพ</b>
                  <input type="file" id="filesmo" ref="filesmo" multiple v-on:change="handleFilesUploadmo()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp"/>
                </label>
              </form>
              <h4>เลือกรูปภาพ</h4>
              <v-layout row wrap  class="containers hidden-md-and-up layoutimagemo" align-center>
                <div style="justify-content: center; margin-left: 2vw; padding-top: 1vh; align-items: center; display: flex;">
                  <v-btn color="primary" @click="uppicmo()" style="height: 70px; border-radius: 10px;">
                    <v-icon style="font-size: 40px;">mdi-plus-circle</v-icon>
                    <!-- <p class="text-xs-center mb-0">อัพโหลดรูปภาพ</p> -->
                  </v-btn>
                </div>
                <div v-for="(file, key) in filesmo" style="justify-content: center; margin-left: 2vw; padding-top: 1vh; align-items: center;">
                  <div v-if="extension(file.file.name) == 'fas fa-file-image'" class="previewimgmobile">
                    <v-btn color="primary" icon flat @click="removeFilemo( key )" style="margin-left: 100px;">
                      <v-icon>close</v-icon>
                    </v-btn>
                    <img v-bind:ref="'preview'+parseInt( key )" style="height: 80px !important; width: 80px !important; display: flex;justify-content: center; margin-top: 10px; align-items: center !important; margin-left: 30px; margin-bottom: 10px;" />
                    <!-- <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 80px !important; width: 80px !important; display: flex;justify-content: center; margin-top: 10px;" /> -->
                    <b class="text2" style="margin-left: 30px;">{{ file.file.name }}</b>
                  </div>
                  <div v-else style="text-align: center; display: grid; justify-content: center;" >
                    <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                </div>
              </v-layout>
              <!-- <v-flex xs12 sm12 md12 xl12 v-if="filesmo.length > 0 " style="overflow-x: scroll; overflow-y: hidden;height: 180px !important; max-width: 100% !important; display: -webkit-inline-box; background: rgb(234, 234, 234); padding-top: 3px;" class="containers hidden-md-and-up">
                <div v-for="(file, key) in filesmo" style="justify-content: center; margin-left: 2vw; padding-top: 1vh; align-items: center; display: flex;">
                  <div v-if="extension(file.file.name) == 'fas fa-file-image'" class="previewimgmobile">
                    <v-btn color="primary" icon flat @click="removeFilemo( key )">
                      <v-icon>close</v-icon>
                    </v-btn>
                    <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 80px !important; width: 80px !important; display: flex;justify-content: center; margin-top: 10px;" />
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                  <div v-else style="text-align: center; display: grid; justify-content: center;" >
                    <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                </div>
              </v-flex> -->
              <br/>
              <v-layout align-center row justify-center>
                <v-btn dark  color="blue"  @click="sendfeedbackmo()" v-if="name !== '' && email !== '' && title.category_TH && detail !== ''">
                  <span >ส่งถึงเรา</span>
              </v-btn>
              <v-btn disabled v-else>
                  <span >ส่งถึงเรา</span>
              </v-btn>
                <v-btn dark style="color: white !important; background: #2662af;"  @click="clear()">
                  <span >ยกเลิก</span>
                </v-btn>
              </v-layout>
            </v-card>
          </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 offset-sm1 class="CSChatThai">
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center" style="text-align: left;">
                <div class="headline CSChatThai">บริษัท วัน เซ็นทริค จำกัด</div>
              </v-card-title>
                <v-card-media height="65vw" src="/static/img/onechat/map.png" >
                </v-card-media>
              <v-layout>
                <v-icon class="blue--text text--lighten-2">place</v-icon>
                <v-card-text class="CSChatThai" style="text-align: left;">
                  บริษัท วัน เซ็นทริค จำกัด 1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16
                  ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ
                  เขตห้วยขวาง กรุงเทพมหานคร 10310
                </v-card-text>
              </v-layout>
              <v-layout >
                <v-icon class="blue--text text--lighten-2">email</v-icon>
                <v-card-text class="CSChatThai" style="text-align: left;">
                  <a href="mailto:onechat@one.th" class="maildata">onechat@one.th</a>
                </v-card-text>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- footer mobile -->
        <v-layout align-center column justify-center style="background-color: white !important;">
          <v-flex xs12 md12>
            <v-layout align-center row justify-center>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black;" @click="toNewTab()">API</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 0px;color: black !important;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 5px;color: black !important;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
          </v-layout>
          </v-flex>
            <v-flex xs12 md12>
            <p style="padding-left: 20px; padding-right: 20px;color: black !important;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          </v-flex>
        </v-layout>
    </div>
</div>
</template>
<script>
  import Navbar from '@/components/homepage/Navbar'
  var _ = require('lodash')
  export default {
    components: {
      Navbar
    },
    data: () => ({
      dragAndDropCapable: false,
      phone: '',
      name: '',
      email: '',
      title: {},
      detail: '',
      items: [],
      files: [],
      filesmo: [],
      borderinputfile: 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;',
      phoneRules: [
        v => (!!v && v.length === 10) || 'กรุณากรอกหมายเลขโทรศัพท์ของคุณจำนวน 10 หลัก',
        v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
        v => /^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
      ],
      emailRules: [
        v => !!v || 'กรุณากรอกอีเมล',
        v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'รูปแบบอีเมลไม่ถูกต้อง'
      ],
      webdev: process.env.WEBchatdev
      // dragAndDropCapable: false,
      // dragAndDropCapablemo: false
      // list_category: []
      // items: [
      //   { icon: 'phone', title: 'โทรศัพท์ : 0-2257-7000' },
      //   { title: 'โทรสาร : 0-2257-1379' },
      //   { title: 'ศูนย์บริการลูกค้า : 0-2257-7269' },
      //   { icon: 'email', title: 'one-platform@inet.co.th' }
      // ]
    }),
    created () {
      this.getsubject()
    },
    watch: {
      files () {
        if (this.files.length > 5) {
          this.$swal(
            '',
            'เลือกรูปภาพได้สูงสุด 5 รูป.',
            'warning'
          )
          _.pullAt(this.files, [5])
        }
      },
      filesmo () {
        if (this.filesmo.length > 5) {
          this.$swal(
            '',
            'เลือกรูปภาพได้สูงสุด 5 รูป.',
            'warning'
          )
          _.pullAt(this.filesmo, [5])
        }
      }
    },
    mounted () {
      this.dragAndDropCapable = this.determineDragAndDropCapable()
      var me =this
      if (this.dragAndDropCapable) {
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
          this.$refs.fileform.addEventListener(evt, function (e) {
            // console.log(evt)
            e.preventDefault()
            e.stopPropagation()
          })
        }.bind(this))
        this.$refs.fileform.addEventListener('dragover', function (e) {
          this.borderinputfile = 'border: 2px dotted #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;'
        }.bind(this))
        this.$refs.fileform.addEventListener('dragleave', function (e) {
          this.borderinputfile = 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;'
        }.bind(this))
        this.$refs.fileform.addEventListener('drop', function (e) {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.files.push({file: e.dataTransfer.files[i], status: 'waiting'})
            this.getImagePreviews()
            // if ( e.target.className == "borderfile" ) {
            this.borderinputfile = 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;'
            // }
          }
        }.bind(this))
      }
    },
    methods: {
      uppic () {
        $('#files').click()
      },
      uppicmo () {
        $('#filesmo').click()
      },
      sendfeedback () {
        var lengthfile = this.files.length
        if (lengthfile === 0) {
          let formData = new FormData()
          formData.append('phone', this.phone)
          formData.append('email', this.email)
          formData.append('comment', this.detail)
          formData.append('name', this.name)
          formData.append('category_id', this.title.category_id)
          this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
            // console.log(response.data)
            this.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success')
            this.cancel()
          }, () => {
            this.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error')
          })
        } else {
          this.sendfeedbackfile()
          // for (var i = 0; i < lengthfile; i++) {
          //   this.sendfeedbackfile(i)
          // }
        }
      },
      sendfeedbackmo () {
        var lengthfile = this.filesmo.length
        if (lengthfile === 0) {
          let formData = new FormData()
          formData.append('phone', this.phone)
          formData.append('email', this.email)
          formData.append('comment', this.detail)
          formData.append('name', this.name)
          formData.append('category_id', this.title.category_id)
          this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
            // console.log(response.data)
            this.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success')
            this.cancel()
          }, () => {
            this.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error')
          })
        } else {
          this.sendfeedbackfilemo()
          // for (var i = 0; i < lengthfile; i++) {
          //   this.sendfeedbackfile(i)
          // }
        }
      },
      sendfeedbackfile () {
        let formData = new FormData()
        var lengthfile = this.files.length
        for (var i = 0; i < lengthfile; i++) {
          var file = this.files[i].file
          formData.append('file', file, file.name)
        }
        // console.log(formData)
        formData.append('phone', this.phone)
        formData.append('email', this.email)
        formData.append('comment', this.detail)
        formData.append('name', this.name)
        formData.append('category_id', this.title.category_id)
        this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
          // console.log(response.data)
          this.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success')
          this.cancel()
        }, () => {
          this.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error')
        })
      },
      sendfeedbackfilemo () {
        let formData = new FormData()
        var lengthfile = this.filesmo.length
        for (var i = 0; i < lengthfile; i++) {
          var file = this.filesmo[i].file
          formData.append('file', file, file.name)
        }
        // console.log(formData)
        formData.append('phone', this.phone)
        formData.append('email', this.email)
        formData.append('comment', this.detail)
        formData.append('name', this.name)
        formData.append('category_id', this.title.category_id)
        this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
          // console.log(response.data)
          this.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success')
          this.cancel()
        }, () => {
          this.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error')
        })
      },
      removeFile (key) {
        this.files.splice(key, 1)
        this.getImagePreviews(key)
      },
      removeFilemo (key) {
        this.filesmo.splice(key, 1)
        this.getImagePreviewsmo(key)
      },
      getImagePreviews (key) {
        for (let i = 0; i < this.files.length; i++) {
          if (/\.(jpe?g|png|gif)$/i.test(this.files[i].file.name)) {
            let reader = new FileReader()
            reader.addEventListener('load', function () {
              this.$refs['preview' + parseInt(i)][0].src = reader.result
            }.bind(this), false)
            reader.readAsDataURL(this.files[i].file)
          } else {
          }
        }
      },
      getImagePreviewsmo (key) {
        for (let i = 0; i < this.filesmo.length; i++) {
          if (/\.(jpe?g|png|gif)$/i.test(this.filesmo[i].file.name)) {
            let reader = new FileReader()
            reader.addEventListener('load', function () {
              this.$refs['preview' + parseInt(i)][0].src = reader.result
            }.bind(this), false)
            reader.readAsDataURL(this.filesmo[i].file)
            // this.extension(this.files[i].name)
            // console.log(this.extension())
          } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
        }
      },
      extension (files) {
        var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
        var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
        var pdf = ['pdf']
        var file = ['ai', 'ps', 'psd']
        var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
        var presentation = ['ppt', 'pps', 'pot', 'pptx']
        var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
        var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
        var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
        if (pdf.includes(extension)) {
          return 'fas fa-file-pdf'
        } else if (archive.includes(extension)) {
          return 'fas fa-file-archive'
        } else if (spreadsheet.includes(extension)) {
          return 'fas fa-file-excel'
        } else if (presentation.includes(extension)) {
          return 'fas fa-file-powerpoint'
        } else if (word.includes(extension)) {
          return 'fas fa-file-word'
        } else if (execution.includes(extension)) {
          return 'fas fa-file-code'
        } else if (image.includes(extension)) {
          return 'fas fa-file-image'
        } else if (file.includes(extension)) {
          return 'fas fa-file'
        } else {
          return 'fas fa-file-alt'
        }
      // return extension[extension.length-1]
      },
      determineDragAndDropCapable () {
        var div = document.createElement('div')
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
      },
      handleFilesUpload (key) {
        let uploadedFiles = this.$refs.files.files
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.files.push({file: uploadedFiles[i], status: 'waiting'})
        }
        this.getImagePreviews(key)
        document.querySelector('#files').value = ''
      },
      handleFilesUploadmo (key) {
        let uploadedFiles = this.$refs.filesmo.files
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.filesmo.push({file: uploadedFiles[i], status: 'waiting'})
        }
        this.getImagePreviewsmo(key)
        document.querySelector('#filesmo').value = ''
      },
      getsubject () {
        this.axios.post(process.env.APImanage + '/getcategory').then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data)
            this.items = response.data
          }
        })
      },
      cancel () {
        this.phone = ''
        this.name = ''
        this.email = ''
        this.title = {}
        this.detail = ''
        this.files = []
        this.filesmo = []
      },
      clear () {
        if (this.name !== '' || this.email !== '' || this.title.category_TH || this.detail !== '') {
          this.$swal({
            title: 'คุณแน่ใจหรือไหม?',
            text: 'เรากำลังลบข้อมูลทั้งหมด ที่คุณกรอก',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'ใช่, ดำเนินการต่อ!',
            cancelButtonText: 'ไม่',
            confirmButtonClass: 'btn btn-danger',
            cancelButtonClass: 'btn btn-success',
            buttonsStyling: true,
            showCloseButton: true,
            reverseButtons: true
          }).then((result) => {
            if (result.value) {
              this.cancel()
            }
          })
        }
      },
      sendme () {
        this.axios.post(process.env.APImanage + '/contactus', {name: this.name, email: this.email, title: this.title.category_TH, detail: this.detail, platform: 'webportal'}).then((response) => {
          if (response.data.status === 'success') {
            this.$swal(
              'ส่งข้อความถึงเรา',
              'ส่งข้อความถึงเราสำเร็จ.',
              'success')
            this.cancel()
          }
        }, (response) => {})
      },
      linkAPI () {
        window.open('/docs', '_blank').focus()
      },
      toPage (page) {
        this.$router.push(page)
      },
      linkregister () {
        window.open('/register').focus()
      },
      linkdownload () {
        window.open('/download').focus()
      },
      toNewTab () {
        window.open(this.webdev, '_blank').focus()
      }
    }
  }
</script>
<style type="text/css" scoped>
.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #00000000 !important;
   color: white;
   text-align: center;
}
.layoutimagemo {
  overflow-x: scroll;
  overflow-y: hidden;
  height: 195px !important;
  max-width: 100% !important;
  display: -webkit-inline-box;
  background: rgb(234, 234, 234);
  padding-top: 3px; background: rgb(255, 255, 255);
  padding-top: 3px;
  border-style: solid;
  border-width: thin;
  border-radius: 10px;
  border-color: #e5e9eb;
}
.previewimgmobile {
  text-align: center;
  display: grid;
  justify-content: center;
  border-style: solid;
  border-width: thin;
  border-radius: 10px;
  width: 140px;
  border-color: #2562af;
  background-color: white;
}
.text2 {
  white-space: nowrap;
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}
[class*='close-'] {
  color: #777;
  font: 14px/100% arial, sans-serif;
  position: absolute;
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
[class*='closemo-'] {
  color: #777;
  font: 14px/100% arial, sans-serif;
  /* position: absolute; */
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.closemo-classic-mobile:after {
  content: '×'; /* ANSI X letter */
  color: #777;
  font: 14px/100% arial, sans-serif;
  /* position: absolute; */
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.containers {
  width: 576px; margin: 0 auto;
}
.containers:after {
  content: '';
  display: block;
  clear: both;
}
.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 95px !important;
  height: 83px !important;
  position: relative;
  background: white;
}


.InputEdit {
    height: 43px;
    width: 100%;
    padding: 5px 15px !important;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
    margin-bottom: 15px !important;
}
>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    /* padding-right: 12px; */
    /*font-size: 14px;*/
    font-size: 14px;
    resize: none;
    height: 75px !important;
}
>>>.v-text-field.v-text-field--full-width.v-input {
    padding: 0;
    padding-left: 12px !important;
}
/*>>>.v-text-field.v-text-field--enclosed {
  margin: 0;
  width: 100%;
  padding: 0;
}
>>>.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__slot textarea, .v-textarea.v-text-field--full-width .v-text-field__slot textarea {
  height: 25px;
  margin-top: 0;
  width: 100%;
}
>>>.v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;
  padding: 0;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none;
}
>>>.v-input__slot {
  border-width: thin;
  border-style: solid;
  border-color: #d2d8dd;
  border-radius: 4px;
}*/
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.btnsendfeed {
  width: 100%;
  color: white;
  border-radius: 5px;
}
a:link {
    text-decoration: none;
    color: black !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #1e88e5 !important;
    text-decoration: none;
}

a:active {
    color: black !important;
    text-decoration: none;
}

>>>.v-text-field.v-text-field--solo .v-input__control {
    min-height: 20px !important;
    padding: 0 !important;
}
>>> .v-text-field.v-text-field--solo .v-label {
    top: calc(50% - 10px) !important;
    font-size: 14px !important;
}
>>> .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    box-shadow: none !important;
    margin-bottom: 3px;
}
>>> .v-text-field.v-text-field--enclosed .v-input__slot {
    padding: 0px;
}
>>>.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__slot textarea, .v-textarea.v-text-field--full-width .v-text-field__slot textarea {
  height: 25px;
  margin-top: 0;
  resize: none;
  font-size: 14px;
  padding-top: 0;
}
>>>.v-messages__message {
    line-height: normal !important;
}
>>> .v-text-field.v-text-field--enclosed .v-text-field__details {
    /* padding: 2px 0px; */
    padding-bottom: 2px;
    padding-left: 0px;
    padding-right: 0px;
}

>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea::placeholder {
  font-size: 14px !important;
  color: #757575 !important;
}

.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 90px !important;
  display: -webkit-inline-box !important;
  background: #2662af !important;
  padding-top: 3px !important;
  border-radius: 4px !important;
  margin-bottom: 15px !important;
}

>>>.theme--light.v-list .v-list__tile--link:hover {
    background: #2562af40 !important;
    /* color: white; */
}


</style>



// WEBPACK FOOTER //
// src/components/homepage/Contact.vue